import React from "react";

export default function PageState({ title, children, loading = false, onRetry, action }) {
  return (
    <div className="app-page-state">
      <div className="app-state-card" role={loading ? "status" : "region"} aria-label={title} aria-live="polite">
        {loading && <span className="app-spinner" aria-hidden="true" />}
        <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
        {children && <div className="mt-3 text-sm leading-6 text-slate-600">{children}</div>}
        {(onRetry || action) && <div className="mt-5 flex flex-wrap justify-center gap-3">
          {onRetry && <button type="button" className="app-button-primary" onClick={onRetry}>Try again</button>}
          {action}
        </div>}
      </div>
    </div>
  );
}
